// URL Utility Functions

/**
 * Check if a string is a valid URL
 */
export const isValidUrl = (string) => {
  if (!string || typeof string !== 'string') {
    return false;
  }
  
  try {
    const url = new URL(string);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (_) {
    return false;
  }
};

/**
 * Check if a URL is an image
 */
export const isImageUrl = (url) => {
  if (!isValidUrl(url)) return false;
  
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.bmp'];
  const lowerUrl = url.toLowerCase();
  return imageExtensions.some(ext => lowerUrl.includes(ext));
};

/**
 * Check if a URL is a document
 */
export const isDocumentUrl = (url) => {
  if (!isValidUrl(url)) return false;
  
  const docExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'];
  const lowerUrl = url.toLowerCase();
  return docExtensions.some(ext => lowerUrl.includes(ext));
};

/**
 * Extract URL from a string (if the string contains a URL)
 */
export const extractUrl = (value) => {
  if (!value || typeof value !== 'string') {
    return null;
  }
  
  // Check if the entire string is a URL
  if (isValidUrl(value)) {
    return value;
  }
  
  // Try to find URL in the string
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const matches = value.match(urlRegex);
  if (matches && matches.length > 0) {
    return matches[0];
  }
  
  return null;
};

/**
 * Get a short display name for a URL
 */
export const getUrlDisplayName = (url) => {
  if (!url) return 'Link';
  
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const filename = pathname.split('/').pop();
    
    if (filename && filename.length > 0 && filename !== '/') {
      return filename.length > 30 ? filename.substring(0, 30) + '...' : filename;
    }
    
    return urlObj.hostname;
  } catch {
    return url.length > 30 ? url.substring(0, 30) + '...' : url;
  }
};

